import CTLBooleanCell from "application/components/CTLBooleanCell";
import CTLUnReadCell from "application/components/CTLUnReadCell";
import DefaultCell from "application/components/DefaultCell";
import RowAction from "application/components/RowAction";
import { setGroupField } from "context";
import { useMaterialUIController } from "context";
// import OutboundViewGateway from "application/components/outboundViewGateway";
import formControl from "globals/form-control";
import { useEffect, useState } from "react";

const Attributes = {
  formSize: "lg",
  columns: 3,
  enableAddButton: true,
  modes: [],
  settingsMode: false,
  enableRefresh: true,
};

const operationURLS = {
  list: "/gateway/list",
  update: "/gateway/update",
  create: "/gateway/create",
  delete: "/gateway/delete",
};

const getColumns = (onDelete, onEdit) => {
  const [controller, dispatch] = useMaterialUIController();
  const { groupField } = controller;
  const [validation, setValidation] = useState("");
  const [formField, setFormField] = useState(false);
  const [required, setRequired] = useState(
    formControl.string().required("Required")
  );
  const [Ip, setIP] = useState(false);
  const checkselect = (e) => {
    const selectedValue = e.target.value;
    if (selectedValue === "sip") {
      setValidation(formControl.string().required("Required").ipv4());
      setIP(true);
    } else if (selectedValue === "pri") {
      setValidation(formControl.string().required("Required").digitsOnly());
      setIP(false);
    } else {
      setValidation(formControl.string().required("Required"));
      setIP(false);
    }
  };

  const customSelect = (e) => {
    const customValue = e.target.value;
    if (customValue === "customType") {
      setFormField(true);

      setRequired(formControl.string().required("Required"));
    } else if (customValue === "sip") {
      setFormField(false);

      setRequired(formControl.string().required("Required"));
    } else if (customValue === "pri") {
      setFormField(false);
    } else if (customValue === "internal") {
      setFormField(false);

      setRequired(formControl.string().required("Required"));
    } else if (customValue === "ngx1") {
      setFormField(false);

      setRequired(formControl.string().required("Required"));
    } else if (customValue === "rlu") {
      setFormField(false);

      setRequired(formControl.string().required("Required"));
    } else {
      setFormField(false);
    }
  };

  const NewSelect = (e) => {
    const value = e.target.value;
    if (value === "CustomGroup") {
      setGroupField(dispatch, true);
    } else {
      setGroupField(dispatch, false);
    }
  };

  return [
    {
      Header: "Action",
      accessor: "id",
      displayInList: true,
      allowInForm: false,
      Cell: ({ row, value }) => (
        <RowAction
          row={row}
          value={value}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ),
    },
    // {
    //   Header: "View",
    //   accessor: "",
    //   displayInList: true,
    //   allowInForm: false,
    //   allowFilter: false,
    //   dataType: "string",
    //   Cell: ({ value, row }) => <OutboundViewGateway value={value} row={row} />,
    // },
    {
      Header: "Gateway Code",
      accessor: "gwCode",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      validation: formControl.string().required("Required"),
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Gateway Name",
      accessor: "gwName",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      validation: formControl.string().required("Required"),
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Select Gateway Type",
      accessor: "gwType",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      onChange: customSelect,
      validation: required,
      Cell: ({ value }) => <DefaultCell value={value} />,
      dataType: "string",
      controlType: "select",
      options: {
        keyField: "id",
        keyDescription: "description",
        values: [
          { id: "sip", description: "SIP" },
          { id: "pri", description: "PRI" },
          { id: "internal", description: "INTERNAL" },
          { id: "ngx1", description: "ngx1" },
          { id: "rlu", description: "RLU" },
          { id: "customType", description: "Custom" },
        ],
      },
    },
    {
      Header: "Custom Gateway Type",
      accessor: "gwTypeCustom",
      displayInList: false,
      allowInForm: formField,
      allowFilter: false,
      dataType: "string",
      validation: formControl.string().required("Required"),
      Cell: ({ value }) => <DefaultCell value={value} />,
    },

    {
      Header: "Range",
      accessor: "gwRange",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "integer",
      validation: formControl.string().required("Required").customFormat(),
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Dial Plan",
      accessor: "dialPlan",
      displayInList: false,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
      onChange: checkselect,
      dataType: "string",
      controlType: "select",
      options: {
        keyField: "id",
        keyDescription: "description",
        values: [
          { id: "sip", description: "SIP" },
          { id: "pri", description: "PRI" },
          { id: "custom", description: "CUSTOM" },
        ],
      },
    },
    {
      Header: "Enter IP(SIP)/Value(PRI)",
      accessor: "dialValue",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      controlType: Ip ? "ip" : "",
      validation: validation,
      Cell: ({ row, value }) => <DefaultCell row={row} value={value} />,
    },
    {
      Header: "Enter IP(SIP)/Value(PRI)",
      accessor: "dialString",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ row, value }) => <DefaultCell row={row} value={value} />,
    },

    {
      Header: "Max Channel",
      accessor: "maxChannel",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "integer",
      defaultValue: 0,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Call Time Out (in sec)",
      accessor: "callTimeout",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "integer",
      validation: formControl.string().required("Required"),
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Caller Strip",
      accessor: "callerStrip",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      defaultValue: "+++++++++++++++",
      validation: formControl.string().validatePlusSymbolsOnly(),
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Destination Strip",
      accessor: "numberStrip",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      defaultValue: "+++++++++++++++",
      validation: formControl.string().validatePlusSymbolsOnly(),
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Group",
      accessor: "gwGroup",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      // onChange: customGroup,
      dataType: "string",
      controlType: "select",
      custom: "NewGroup",
      validation: formControl.string().required("Required"),
      onChange: NewSelect,
      Cell: ({ value }) => <DefaultCell value={value} />,
      options: {
        keyField: "gwGroup",
        keyDescription: "gwGroup",
        values: [],
        url: "/gateway/list/gwGroup",
      },
    },
    {
      Header: "Custom Group Name",
      accessor: "gwGroupCustom",
      displayInList: true,
      allowInForm: groupField,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Pulse In Second)",
      accessor: "pulseInSecond",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Pulse Rate",
      accessor: "pulseRate",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "NMS Controlled CAC",
      accessor: "nmsCac",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <CTLBooleanCell value={value} />,
    },
    {
      Header: "Recording",
      accessor: "isRecording",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <CTLBooleanCell value={value} />,
    },
    {
      Header: "QSIG",
      accessor: "qsig",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <CTLBooleanCell value={value} />,
    },
    {
      Header: "Fail Over Gateway",
      accessor: "failOverGateway",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Fail Over ISDN Cause",
      accessor: "failoverIsDnCause",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Minimum Duration",
      accessor: "minDuration",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Enhanced Duration",
      accessor: "enhancedDuration",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Beep Interval(in sec)",
      accessor: "beepInterval",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },

    {
      Header: "Allow Extend Time",
      accessor: "allowExtendTime",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Tenant Code",
      accessor: "tenantCode",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Efficiency Percentage",
      accessor: "efficiencyPer",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Code Provision",
      accessor: "codec",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Fail Over Max try",
      accessor: "failoverMaxTry",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Fail Over Try",
      accessor: "failOverTry",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Priority",
      accessor: "priority",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Peer To Peer",
      accessor: "peerToPeer",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <CTLBooleanCell value={value} />,
    },
    {
      Header: "Max Out Digit",
      accessor: "maxOutDigit",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "PreFix",
      accessor: "prefix",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Gateway Controller Code",
      accessor: "gatewayControllerCode",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
    },
    {
      Header: "Gateway Testing Number",
      accessor: "gatewayTestingNumber",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Gateway Testing CLI",
      accessor: "gatewayTestingCli",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Handle ISDN Cause",
      accessor: "handleIsDnCause",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <CTLBooleanCell value={value} />,
    },
    {
      Header: "Failover Number",
      accessor: "failOverNumber",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Fail Over Timeout",
      accessor: "extFailoverTimeout",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "CAC Bandwidth",
      accessor: "cacBandwidth",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Toll Free",
      accessor: "tollFree",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <CTLBooleanCell value={value} />,
    },
    {
      Header: "CLI Prefix",
      accessor: "cliPrefix",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "DTMF Tone",
      accessor: "allowDTmfTone",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <CTLBooleanCell value={value} />,
    },
    {
      Header: "STD Code Prefix",
      accessor: "stdCodePrefix",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "ISD Code Prefix",
      accessor: "isdCodePrefix",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Local Code Prefix",
      accessor: "localCodePrefix",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
  ];
};

export { getColumns, Attributes, operationURLS };
